import request from '@client/utils/request';
import { buildUrl, Service } from '@client/utils/build-url';
import { api } from '@client/utils/url';

export interface DriverGpsRelation {
  stopInstantUuid: string;
  legUuid: string;
  driverUuid: string;
  stopUuid: string;
  ingressTime: string | null;
  egressTime: string | null;
  appointmentStart: string | null;
  appointmentEnd: string | null;
}

export interface UpdateDriverGpsRelationIngressEgress {
  stopInstantUuid: string;
  legUuid: string;
  driverUuid: string;
  stopUuid: string;
  stopDepartmentUuid: string | null;
  appointmentStart: string | null;
  appointmentEnd: string | null;
  ingressTime?: string;
  egressTime?: string;
}

export async function fetchDriverGpsRelations(stopUuids: string[]): Promise<Record<string, DriverGpsRelation[]>> {
  const response = await request<{ data: Record<string, DriverGpsRelation[]> }>(
    buildUrl(Service.GPS, '/api/driver-gps-relations').toString(),
    { query: { stopUuids } }
  );

  return response?.data ?? {};
}

export async function updateDriverGpsRelationIngressEgress(relations: UpdateDriverGpsRelationIngressEgress[]) {
  await request(buildUrl(Service.GPS, '/api/driver-gps-relations/update-ingress-egress-times').toString(), {
    method: 'POST',
    body: JSON.stringify(relations)
  });
}

export async function updateStopInstantActualDateTime(stopInstantUuid: string, actualDateTime: string) {
  await request(api('/stop-instants'), {
    method: 'PATCH',
    body: JSON.stringify({
      data: [{ type: 'stopInstant', id: stopInstantUuid, attributes: { actualDateTime } }]
    })
  });
}
